import { render } from "./memberRights.vue?vue&type=template&id=38974318"
import script from "./memberRights.vue?vue&type=script&lang=js"
export * from "./memberRights.vue?vue&type=script&lang=js"

import "./memberRights.vue?vue&type=style&index=0&id=38974318&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__